import { translate } from 'i18n/i18n'
import type { Moment } from 'moment-timezone'

export const DayColumnHeader = ({ day }: { day: Moment }) => {
  return (
    <div>
      <div css={{ fontWeight: 'bold' }}>{translate.dates.format(day, 'ddd').toUpperCase()}</div>
      <div css={{ fontSize: 12 }}>{translate.dates.format(day, 'MMM D')}</div>
    </div>
  )
}
